import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import usePermissions from '../../../../../../hooks/usePermissions'

import { insertIf } from '../../../../../../helpers/common'
import { openForm } from '../../../../../../modules/actions/forms'
import { updateAssetGroup } from '../../../../../../modules/actions/assets'

import { listItemChangeStatus } from '../../../../../../constants/other'
import { ASSET_GROUP_GOOGLE_ADS_EDIT, CHANGE_ASSET_GROUP_HISTORY } from '../../../../../../constants/forms'

const useAssetGroupsActions = () => {
  const dispatch = useDispatch()
  const permissions = usePermissions()

  const editAssetGroupHandler = useCallback(
    (id, isInternal) =>
      dispatch(
        openForm({
          id,
          formName: ASSET_GROUP_GOOGLE_ADS_EDIT,
          ...(isInternal && { otherParams: 'internal=true' })
        })
      ),
    [dispatch]
  )

  const changeAdStatusHandler = useCallback(
    (id, account, status) => {
      dispatch(
        updateAssetGroup(
          {
            status: listItemChangeStatus[status].changeTo,
            account
          },
          id
        )
      )
    },
    [dispatch]
  )

  return useCallback(
    ({ id, account, status, internal, approval_status: assetGroupApprovalStatus }) => {
      const isInternalAd = assetGroupApprovalStatus === 'pending_approval' || !!internal

      return [
        ...insertIf(permissions.can('update', 'Ad'), {
          text: 'Edit',
          onClickHandler: () => editAssetGroupHandler(id, isInternalAd)
        }),
        ...insertIf(!isInternalAd, {
          text: status === 'active' ? 'Pause' : 'Activate',
          onClickHandler: () => changeAdStatusHandler(id, account, status)
        }),
        {
          text: 'Change History',
          onClickHandler: () => dispatch(openForm({ id, formName: CHANGE_ASSET_GROUP_HISTORY }))
        }
      ]
    },
    [permissions, changeAdStatusHandler, editAssetGroupHandler, dispatch]
  )
}

export default useAssetGroupsActions
